import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiAngularModule } from 'ui-angular/ui-angular';

import { CheckListsComponent } from './components/check-lists/check-lists.component';
import { CheckListsRoutingModule } from './check-lists-routing.module';
import { AppUiModule } from '../../../../ui/app-ui.module';
import { CheckListsQuestionComponent } from './components/check-lists-question/check-lists-question.component';
import { BoolAnswerComponent } from './components/bool-answer/bool-answer.component';
import { StringAnswerComponent } from './components/string-answer/string-answer.component';
import { ChoicesMultipleAnswerComponent } from './components/choices-multiple-answer/choices-multiple-answer.component';
import { ChoicesAnswerComponent } from './components/choices-answer/choices-answer.component';
import { CoordinateAnswerComponent } from './components/coordinate-answer/coordinate-answer.component';
import { CameraAnswerComponent } from './components/camera-answer/camera-answer.component';
import { ImageAnswerComponent } from './components/image-answer/image-answer.component';
import { IntegerAnswerComponent } from './components/integer-answer/integer-answer.component';
import { QuestionDialogComponent } from './components/question-dialog/question-dialog.component';
import { CheckListsFiltersComponent } from './components/check-lists-filters/check-lists-filters.component';
import { QualityKeeperAnswerComponent } from './components/quality-keeper-answer/quality-keeper-answer.component';
import { CheckListsLocalComponent } from './components/check-lists-local/check-lists-local.component';
import { CreateLocalChecklistDialogComponent } from './components/create-local-checklist-dialog/create-local-checklist-dialog.component';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { PortAnswerComponent } from './components/port-answer/port-answer.component';
import { CheckListsSharedModule } from '../shared/check-lists-shared.module';
import { SpeedtestAnswerComponent } from './components/speedtest-answer/speedtest-answer.component';
import { CreateGlobalChecklistDialogComponent } from './components/create-global-checklist-dialog/create-global-checklist-dialog.component';
import { CheckListsGlobalProblemComponent } from './components/check-lists-global-problem/check-lists-global-problem.component';

@NgModule({
    imports: [CommonModule, CheckListsRoutingModule, AppUiModule, ReactiveFormsModule, FormsModule, PipesModule, CheckListsSharedModule, UiAngularModule],
    declarations: [
        CheckListsComponent,
        CheckListsQuestionComponent,
        BoolAnswerComponent,
        StringAnswerComponent,
        ChoicesMultipleAnswerComponent,
        ChoicesAnswerComponent,
        CoordinateAnswerComponent,
        CameraAnswerComponent,
        ImageAnswerComponent,
        IntegerAnswerComponent,
        QuestionDialogComponent,
        CheckListsFiltersComponent,
        CheckListsLocalComponent,
        CreateLocalChecklistDialogComponent,
        PortAnswerComponent,
        QualityKeeperAnswerComponent,
        SpeedtestAnswerComponent,
        CreateGlobalChecklistDialogComponent,
        CheckListsGlobalProblemComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CheckListsModule {}
